import React, { Component } from 'react';
import { connect } from "react-redux";
import 'react-quill/dist/quill.snow.css';
import { sendMail } from '../../../actions/complaintsDataAction';
import moment from 'moment';
import { getSCConversationData } from '../../../actions/serviceCenterActions';
import ReactModal from 'react-modal';
import ConversationExpand from './ConversationExpand';

const customStyles = {
  overlay: {
    background: 'rgba(0, 0, 0, 0.5)',
    overflow: "scroll"
  },
  content: {
    inset: '0 0 auto',
    marginRight: '0',
    transform: 'translate(0)',
    background: '#1a1a1a',
    padding: '2rem',
    border: 'none',
    width: '100%',
    position: 'absolute',
    overflow: 'scroll',
    height: '100%'
  },
};

class Conversations extends Component {
  constructor() {
    super();
    this.state = {
      showExpandedConversation: false,
      pageno: 0,
      SCConversationList: [],
      isLoading: false,
    };
    this.showConversation = this.showConversation.bind(this);
    this.expandFunction = this.expandFunction.bind(this);
  }

  componentDidMount() {
    this.getConversationComplaits();
    var myDiv = document.getElementById("conversation_head");
    // myDiv.scrollTop = myDiv.scrollHeight - myDiv.clientHeight;
  }


  getConversationComplaits = async () => {
    this.setState({ isLoading: true });
    let response = await this.props.getSCConversationData(this.props.complaintsDetail.id, this.state.pageno);
    this.setState({ SCConversationList: response, isLoading: false });
  };


  showConversation() {
    this.setState({ showExpandedConversation: true });
  }

  expandFunction = async (val) => {
    this.setState({ showExpandedConversation: val });
    let response = await this.props.getSCConversationData(this.props.complaintsDetail.id, 1);
    this.setState({ SCConversationList: response });
  };

  loadMore = async () => {
    let response = await this.props.getSCConversationData(this.props.complaintsDetail.id, this.state.pageno + 1);
    this.setState({ SCConversationList: [...this.state.SCConversationList, ...response], pageno: this.state.pageno + 1 });
  };

  render() {
    let userRoleId = localStorage.getItem('userRoleId');
    let userEmail = localStorage.getItem('userEmail');

    return (
      <div>
        {!this.state.isLoading ?
          <div>
            {userRoleId !== '4' &&
              <div className="expand_wrapper" onClick={this.showConversation}>
                <i className="fa fa-expand" aria-hidden="true"></i>
              </div>
            }
            <div className="head conversation_head" id="conversation_head">
              {
                this.state.SCConversationList.map((b, index) => (
                  <div key={b.id} style={{ width: "100%", float: "left" }}>
                    {!b.user &&
                      <div>
                        {b.from_email != null
                          ?
                          <div id="coversation_body" className={b.from_email !== "NOISE <help@nexxbase.com>" && 'incoming'} >

                            <div>
                              {b.from_email !== "NOISE <help@nexxbase.com>" &&
                                <h3>Customer Reply</h3>
                              }
                              <p>{b.body_text}</p>
                              <p id="created_at">{moment(b.created_at, ["MMMM DD, YYYY || HH.mm"]).format('MMMM DD, YYYY || hh:mm A')}</p>
                            </div>

                          </div>
                          :
                          <div id="coversation_body" className={b.to_emails === '' && "yellowBG"} >
                            <div>
                              <p>{b.body_text}</p>
                              <p id="created_at">{moment(b.created_at, ["MMMM DD, YYYY || HH.mm"]).format('MMMM DD, YYYY || hh:mm A')}</p>
                            </div>
                          </div>
                        }

                      </div>}
                  </div>
                ))
              }
              {this.props.SCconversationpage.next_page == true &&
                <div className="expand_wrapper" onClick={this.loadMore}>
                  <button className='loadMoreBUtton'>Load more..</button>
                </div>}

            </div>
          </div> :
          <div>
            <i id="loadingText">Please wait ....</i>
          </div>
        }


        <ReactModal
          isOpen={this.state.showExpandedConversation}
          contentLabel="Minimal Modal Example"
          style={customStyles}
          ariaHideApp={false}
          id="conversationExpand"
        >
          <ConversationExpand complaintId={this.props.complaintsDetail.id} showExpandedConversation={this.expandFunction} ConversationData={this.state.SCConversationList} pageno={this.state.pageno} />
        </ReactModal>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  conversationData: state.serviceCenter.conversationData,
  complaintsDetail: state.serviceCenter.complaintsDetail,
  commentsData: state.serviceCenter.complaintsDetail,
  SCconversationDetails: state.serviceCenter.SCconversationDetails,
  SCconversationpage: state.serviceCenter.SCconversationpage
});

export default connect(mapStateToProps, { sendMail, getSCConversationData })(Conversations);